<template>
  <div class="setValidate" ref="setValidate">
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px">校验规则</div>
      <validate-condition-editor
        v-model="tempNodeData.items"
        :flowConnectedData="workflowVarList"
        :flowVarGroup="workflowVarGroup"
        :validateExtra="extra"
        v-on="$listeners"
        :workflow-var-group-string-map="workflowVarGroupStringMap"
      ></validate-condition-editor>
    </div>
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px">校验设置</div>
      <el-checkbox v-model="tempNodeData.sendMsg">
        是否发送消息至消息中心
      </el-checkbox>
    </div>
  </div>
</template>

<script>
import { deepClone } from "@/utils/common"
import ValidateConditionEditor from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/ValidateConditionEditor"

export default {
  name: "setValidate",
  components: { ValidateConditionEditor },
  props: {
    nodeInfo: Object,
    workflowVarList: Array,
    workflowVarGroup: Array,
    extra: Object,
    workflowVarGroupStringMap: Object
  },
  data() {
    return {
      tempNodeData: {}
    }
  },
  watch: {
    "tempNodeData.items": {
      immediate: true,
      handler() {
        if (!this._.isEmpty(this.tempNodeData.items)) {
          this.$set(this.extra, "description", {
            messages: this.tempNodeData?.items.map(item => item.msgShow)
          })
        }
      }
    }
  },
  created() {
    this.tempNodeData = deepClone(this.nodeInfo).data
  },
  methods: {}
}
</script>

<style lang="scss">
.setValidate {
}
</style>
